import { isoToDate, useCallback } from "@";
import { predefinedColorSets } from "./options";

// Hook to handle form filling for association info
export const useInfo = (reset, setValue) => {
  const fillForm = useCallback(
    (data) => {
      let initialCenter;
      try {
        initialCenter = data?.locationOnMap
          ? JSON.parse(data?.locationOnMap)
          : { lat: 24.7136, lng: 46.6753 };
      } catch (e) {
        initialCenter = { lat: 24.7136, lng: 46.6753 };
      }
      const licenseEndDate = isoToDate(data?.licenseEndDate);

      reset({
        ...data,
        locationOnMap: initialCenter,
        licenseEndDate,
      });

      setValue("summary", data?.summary);
    },
    [reset, setValue],
  );

  return { fillForm };
};

// Hook to handle theme colors form filling
export const useThemeColors = (setValue) => {
  const def = "#41B06E,#141E46,#000000";

  const fillForm = useCallback(
    (data) => {
      setValue("customCss", data?.customCss);
      const fetchedColors = data?.styles?.join(",") || def;

      if (predefinedColorSets.includes(fetchedColors)) {
        setValue("themeValues", fetchedColors);
      } else {
        const colors = fetchedColors.split(",");
        const [colorA = "#000000", colorB = "#000000", colorC = "#000000"] =
          colors;
        setValue("colorA", colorA);
        setValue("colorB", colorB);
        setValue("colorC", colorC);
        setValue("themeValues", fetchedColors);
      }
    },
    [setValue],
  );

  return { fillForm };
};
